import { IChangeMsisdnOrchestrator } from "@nju/data-access-portal-orchestrator";
import { IconName } from "@nju/icons";

interface IStatusProps {
  iconName: IconName;
  title: string;
  text: string;
}

interface IGetChangeMsisdnStatusDataProps {
  orchestrator: IChangeMsisdnOrchestrator;
}

export function getChangeMsisdnStatusData({
  orchestrator,
}: IGetChangeMsisdnStatusDataProps): IStatusProps | undefined {
  if (
    orchestrator.state === "ORDER_FULFILLMENT" ||
    orchestrator.state === "ORDER_COMMITTED"
  ) {
    return {
      title: "numer jest w trakcie zmiany",
      text: "Potwierdzamy możliwość zmiany Twojego numeru.",
      iconName: "spinner",
    };
  }

  return undefined;
}
